module.exports = __webpack_public_path__ + "img/7b6da60.jpeg";